// OC MENA Festival — Charity Master List
// Each ticket purchase allows the buyer to select a country + category
// Two organizations are shown per selection
// 19 countries in ABC order (Somalia removed from frontend but kept in backend for existing orders)

const charityData = [
  {
    country: 'Algeria',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Oran International Arabic Film Festival', url: 'https://oranfestivaldz.com/en/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'SOS Children\'s Villages Algeria', url: 'https://www.sos-childrensvillages.org/news/withdrawal-algeria' }
      ]
    }
  },
  {
    country: 'Bahrain',
    flag: '🇧🇭',
    categories: {
      'Arts & Crafts': [
        { name: 'Riwaq Art Space', url: 'https://www.alriwaqartspace.com/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Bahrain Red Crescent Society', url: 'https://rcsbahrain.org/en/' }
      ]
    }
  },
  {
    country: 'Egypt',
    flag: '🇪🇬',
    categories: {
      'Arts & Crafts': [
        { name: 'Hanager Arts Center', url: 'https://www.cuipcairo.org/en/directory/el-hanager-arts-center' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Resala Charity Organization', url: 'https://www.resala.org/' }
      ]
    }
  },
  {
    country: 'Iran',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Iran Heritage Foundation', url: 'https://ihf.org.uk/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Children of Persia', url: 'https://www.childrenofpersia.org/' }
      ]
    }
  },
  {
    country: 'Iraq',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Al-Mada Foundation for Media and Culture', url: 'https://almadapaper.net/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Iraq Red Crescent Society', url: 'https://ircs.org.iq/en/home/' }
      ]
    }
  },
  {
    country: 'Jordan',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Jordan National Gallery of Fine Arts', url: 'https://nationalgallery.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Jordan Hashemite Charity Organization', url: 'https://jhco.org.jo/' }
      ]
    }
  },
  {
    country: 'Kuwait',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Al Sadu Society', url: 'https://alsadu.org.kw/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Kuwait Red Crescent Society', url: 'https://www.krcs.org.kw/' }
      ]
    }
  },
  {
    country: 'Lebanon',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Beirut Art Center', url: 'https://beirutartcenter.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Food Blessed', url: 'https://foodblessed.org/' }
      ]
    }
  },
  {
    country: 'Libya',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Tilwan Organization for Art and Culture', url: 'https://tilwan.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Libyan Red Crescent', url: 'https://www.ifrc.org/national-societies-directory/libyan-red-crescent' }
      ]
    }
  },
  {
    country: 'Morocco',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'The Anou', url: 'https://www.theanou.com/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Bayti Association', url: 'https://association-bayti.ma/' }
      ]
    }
  },
  {
    country: 'Oman',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'British Omani Society Art Group', url: 'https://www.britishomani.org/art' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Dar Al Atta\'a', url: 'https://daralatta.org/category/campaigns/' }
      ]
    }
  },
  {
    country: 'Palestine',
    flag: '🇵🇸',
    locked: true,
    categories: {
      'Arts & Crafts': [
        { name: '2048 Foundation', url: 'https://2048foundation.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'HEAL Palestine', url: 'https://www.healpalestine.org/' }
      ]
    }
  },
  {
    country: 'Qatar',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Fire Station: Artist in Residence', url: 'https://www.firestation.ie/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Qatar Red Crescent Society', url: 'https://www.ifrc.org/national-societies-directory/qatar-red-crescent-society' }
      ]
    }
  },
  {
    country: 'Saudi Arabia',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Turquoise Mountain', url: 'https://www.turquoisemountain.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'King Khalid Foundation', url: 'https://kkf.org.sa/en/' }
      ]
    }
  },
  {
    country: 'Sudan',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Sudan Artist Fund', url: 'https://www.jameelartshealthlab.org/outreach/artist-projects/sudan-artist-fund' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Sudanese Red Crescent', url: 'https://www.srcs.sd/en' }
      ]
    }
  },
  {
    country: 'Syria',
    flag: '🇸🇾',
    categories: {
      'Arts & Crafts': [
        { name: 'Syrians for Heritage', url: 'https://syriansforheritage.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'The White Helmets', url: 'https://whitehelmets.org/' }
      ]
    }
  },
  {
    country: 'Tunisia',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Carthage Film Festival Association', url: 'https://jcctunisie.org/en/page/comite' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Tunisian Red Crescent', url: 'https://www.croissant-rouge.tn/' }
      ]
    }
  },
  {
    country: 'UAE',
    flag: '��',
    categories: {
      'Arts & Crafts': [
        { name: 'Abu Dhabi Music & Arts Foundation', url: 'https://admaf.org/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'Dubai Cares', url: 'https://www.dubaicares.ae/' }
      ]
    }
  },
  {
    country: 'Yemen',
    flag: '🇾🇪',
    categories: {
      'Arts & Crafts': [
        { name: 'Yemen Noor Foundation for Education and Relief', url: 'https://yenof.org/en/' }
      ],
      'Poverty / Humanitarian Aid': [
        { name: 'International Committee of the Red Cross Yemen', url: 'https://www.icrc.org/en/where-we-work/yemen' }
      ]
    }
  }
];

export default charityData;
